import axios from 'axios';

export function scrollTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
}

export function setPageTitle(title, logoTreatment) {
  let product;
  switch (logoTreatment) {
    case 'channels':
      product = 'Pearson+ Channels';
      break;
    case 'turbo':
    case 'pearson_plus':
      product = 'Pearson+';
      break;
    case 'accelerated_pathways':
      product = 'Pearson Accelerated Pathways';
      break;
    case 'btec_classrooms':
      product = 'Pearson BTEC';
      break;
    case 'clinical_canada':
      product = 'Pearson Clinical Assessment';
      break;
    case 'erpi':
      product = 'Pearson ERPI - MaBiblio';
      break;
    case 'maryville':
      product = 'Pearson Maryville University';
      break;
    case 'mathology':
      product = 'Pearson Mathology';
      break;
    case 'monlab_xl':
      product = 'Pearson ERPI';
      break;
    case 'mpp_italy':
      product = 'Sanoma';
      break;
    case 'regis':
      product = 'Pearson Regis College';
      break;
    case 'revise_plus_exam_prep':
      product = 'Pearson Revise';
      break;
    case 'test_hub':
      product = 'Pearson English Test Hub';
      break;
    default:
      product = 'Pearson'; // p.com and legacy
      break;
  }
  document.title = `${title}  |  ${product}`;
}

export function updateQueryStringParameter(url, key, value) {
  let urlPath = url;
  const re = new RegExp(`([?|&])${key}=.*?(&|#|$)`, 'i');
  if (urlPath.match(re)) {
    return urlPath.replace(re, `$1${key}=${value}$2`);
  }
  let hash = '';
  const separator = urlPath.indexOf('?') !== -1 ? '&' : '?';
  if (urlPath.indexOf('#') !== -1) {
    hash = urlPath.replace(/.*#/, '#');
    urlPath = urlPath.replace(/#.*/, '');
  }
  return `${urlPath}${separator}${key}=${value}${hash}`;
}

// Based on the accepted answer to this stackoverflow question: https://tinyurl.com/u4l245c
export const getFile = async (filename, httpPath, accessToken, successCallback, failureCallback) => {
  try {
    // Make the request using axios
    const response = await axios.get(httpPath, {
      headers: {
        accept: '*/*',
        'x-authorization': accessToken,
      },
      responseType: 'arraybuffer',
    });

    let success = false;
    let blob = null;
    let url = '';
    const mimeType = 'application/pdf';

    try {
      // Create a Blob from the response data
      blob = new Blob([response.data], { type: mimeType });

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);// For IE
      } else {
        const saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
        if (saveBlob) {
          saveBlob(blob, filename);
        } else {
          throw new Error('SaveBlob not supported');
        }
      }

      success = true;
      successCallback();// Call success callback
    } catch (error) {
      // Fall back to creating a download link
      const urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
      if (urlCreator) {
        const link = document.createElement('a');
        url = urlCreator.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);

        // Simulate a click to start the download
        const event = new MouseEvent('click', { bubbles: true, cancelable: true });
        link.dispatchEvent(event);

        success = true;
        successCallback();
      }
    }

    // If no download method worked, trigger the failure callback
    if (!success) {
      failureCallback();
    }
  } catch (error) {
    console.error('Request failed', error);
    failureCallback();
  }
};
